import Input from '@/Components/Input/Input';
import type NewWordsStore from '@/Stores/NewWords/NewWordsStore';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Styles from './NewWordsOnKeyDownInputSearch.module.scss';

const NewWordsOnKeyDownInputSearch = observer(({ store }: { store: NewWordsStore }): React.ReactElement => {
    const { t } = useTranslation();

    const handleOnEnter = (
        event: React.KeyboardEvent<HTMLInputElement>,
    ): void => {
        store.reload();
    };

    return (
        <div className={Styles.input}>
            <Input light={true} value={store.state.globalFilter} onChange={(e) => store.setGlobalFilter(e.target.value)} label={t('Search')} onEnter={handleOnEnter} />
        </div>
    );
});

export default NewWordsOnKeyDownInputSearch;
